import React, { FCX } from 'react';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';
import { FluidObject } from 'gatsby-image';
import { DeepReadonly } from 'utility-types';

type InputProps = Readonly<{
  filename: string;
  width?: number;
  height?: number;
}>;

type Props = DeepReadonly<{
  images: {
    edges: {
      node: {
        relativePath: string;
        publicURL: string;
        extension: string;
        childImageSharp: {
          fluid: FluidObject;
        };
      };
    }[];
  };
}>;

const Component: FCX<InputProps> = ({ className, filename, width, height }) => {
  const data = useStaticQuery<Props>(graphql`
    query {
      images: allFile {
        edges {
          node {
            relativePath
            publicURL
            extension
            childImageSharp {
              fluid(maxWidth: 1920, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `);

  const sizeProps: Record<string, any> = {};
  if (width) {
    sizeProps.width = width + 'px';
  }
  if (height) {
    sizeProps.height = height + 'px';
  }

  const image = data.images.edges.find((edge) => edge.node.relativePath.includes(filename));

  if (!image) {
    return <img alt='not found' {...sizeProps} className={className} />;
  }

  if (image.node.extension === 'svg') {
    return <img src={image.node.publicURL} alt='' {...sizeProps} className={className} />;
  }
  return (
    <Img fluid={image.node.childImageSharp?.fluid} alt='' {...sizeProps} className={className} />
  );
};

export default Component;
